import { render, staticRenderFns } from "./detailcn.vue?vue&type=template&id=797780aa&"
import script from "./detailcn.vue?vue&type=script&lang=js&"
export * from "./detailcn.vue?vue&type=script&lang=js&"
import style0 from "./detailcn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports